import { useIsMobile } from '@/hooks/useIsMobile';

/** Where the split folds to one column — `$split-breakpoint` in `_base.scss`, same number. */
export const SPLIT_BREAKPOINT = 1156;

/**
 * Whether SplitLayout is folded, for a page that places something differently then — a
 * destructive row that ends the page instead of sitting under the contact buttons. Which
 * column shows needs none of this: the stylesheet decides it from `open`.
 */
export const useSplitFolded = () => useIsMobile({ breakpoint: SPLIT_BREAKPOINT });
